import { useState, useEffect } from 'react'

import i18n from '@/i18n'

export const useFullscreen = (onError) => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement)
    }

    document.addEventListener('fullscreenchange', handleFullscreenChange)

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange)
    }
  }, [])

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      if (!document.documentElement.requestFullscreen) {
        if (onError) {
          onError(i18n.t('package-room:fullscreen.notSupported'))
        }
        return
      }

      document.documentElement
        .requestFullscreen()
        .then(() => {
          setIsFullscreen(true)
        })
        .catch((err) => {
          if (onError) {
            onError(`Error attempting to enable fullscreen: ${err.message}`)
          }
        })
    } else {
      if (document.exitFullscreen) {
        document
          .exitFullscreen()
          .then(() => {
            setIsFullscreen(false)
          })
          .catch((err) => {
            if (onError) {
              onError(`Error attempting to exit fullscreen: ${err.message}`)
            }
          })
      }
    }
  }

  return {
    isFullscreen,
    toggleFullscreen,
  }
}
